import LegalPage from "@/pages/LegalPage";

const SECTIONS = [
  {
    heading: "Introduction",
    paragraphs: [
      "30 North Transportation Inc. (\u201c30 NORTH\u201d, \u201cwe\u201d, \u201cus\u201d) respects your privacy. This Privacy Policy explains how we collect, use, share and protect personal information when you visit www.30north.ca or contact us, including when you submit a quote request through this website.",
      "This Privacy Policy explains how 30 North Transportation Inc. collects, uses, and handles personal information in connection with this website and our quote request process.",
    ],
  },
  {
    heading: "Information We Collect",
    paragraphs: [
      "Information you provide directly: when you submit a quote request or contact us, we collect the details you choose to share, such as your name, company name, email address, phone number, pickup and delivery locations, shipment details, dates and any additional notes you include.",
      "Information collected automatically: like most websites, we may collect basic technical information when you visit, such as your browser type, device type and general usage information, through standard website hosting and analytics functions.",
    ],
  },
  {
    heading: "How We Use Information",
    paragraphs: [
      "We use the information we collect to respond to quote requests and inquiries, coordinate and manage transportation solutions, communicate with you about your shipments or requests, operate and improve our website, and meet legal or regulatory obligations.",
    ],
  },
  {
    heading: "How We Share Information",
    paragraphs: [
      "We do not sell your personal information. We may share information with transportation and logistics partners only where needed to coordinate or fulfill a shipment you have requested, with service providers that help us operate our website and communications, and where required by law or to protect our legal rights.",
    ],
  },
  {
    heading: "Communications",
    paragraphs: [
      "When you submit a quote request or contact us, we will use your contact details to respond to you about that request. If you wish to stop receiving communications from us, you can let us know at any time using the contact details below.",
    ],
  },
  {
    heading: "Data Security",
    paragraphs: [
      "We use reasonable administrative and technical measures to protect the personal information we hold. However, no method of transmission or storage is completely secure, and we cannot guarantee absolute security.",
    ],
  },
  {
    heading: "Data Retention",
    paragraphs: [
      "We keep personal information only as long as needed to fulfill the purposes described in this policy, including responding to your requests, coordinating transportation, and meeting any legal or record-keeping requirements.",
    ],
  },
  {
    heading: "Website / Cookies",
    paragraphs: [
      "This website may use cookies or similar technologies for basic functionality and to understand general website usage. Most browsers allow you to control or disable cookies through your browser settings; doing so may affect how some parts of the website function.",
    ],
  },
  {
    heading: "Third-Party Services",
    paragraphs: [
      "We rely on trusted service providers to operate certain parts of this website, such as website hosting and email delivery for form submissions. These providers process information on our behalf and only as needed to provide their services to us.",
    ],
  },
  {
    heading: "Your Privacy Rights",
    paragraphs: [
      "You may request access to the personal information we hold about you, ask us to correct it, or withdraw your consent to our use of it, subject to legal requirements. To make a request, contact us using the details below.",
    ],
  },
  {
    heading: "Changes to This Privacy Policy",
    paragraphs: [
      "We may update this Privacy Policy from time to time. The current version will always be posted on this page with its updated date.",
    ],
  },
  {
    heading: "Contact Us",
    paragraphs: [
      "If you have any questions about this Privacy Policy or how we handle personal information, please contact us using the details below.",
    ],
  },
];

export default function PrivacyPolicy() {
  return (
    <LegalPage
      title="Privacy Policy"
      description="Read the 30 NORTH Privacy Policy covering information collected through our website and quote request process."
      path="/privacy-policy"
      updated="July 2026"
      intro="This Privacy Policy applies to www.30north.ca and to the quote request and contact features offered through it."
      sections={SECTIONS}
      testid="privacy-policy-page"
    />
  );
}
